import { memo, MouseEvent, useEffect, useState } from 'react'
import { IconButton, Menu, MenuItem } from '@mui/material'
import { IScheduleIconComponent } from '../../../Models'
import { DataPinnedItemIcon, DataUnpinnedItemIcon, RedCrossIcon } from '../../Icons'
import {
  AccessTime,
  KeyboardArrowDown,
  KeyboardArrowUp,
  SettingsOutlined,
} from '@mui/icons-material'
import scheduleIconStyle from './ScheduleIcon.module.scss'

const ScheduleIconComponent = ({
  data,
  disabled,
  handleScheduleClick,
  isPinnedItemDisabled,
  type,
  pinningSetting,
}: IScheduleIconComponent) => {
  const [isIconDisabled, setIsIconDisabled] = useState(false)
  const [editScheduleAnchorEl, setEditScheduleAnchorEl] = useState<null | HTMLElement>(null)

  useEffect(() => {
    setIsIconDisabled(isPinnedItemDisabled || disabled)
  }, [isPinnedItemDisabled, disabled])

  const handleClose = () => {
    setEditScheduleAnchorEl(null)
  }

  const isScheduledCheck =
    pinningSetting?.isCevronSupported && (data?.isScheduled || data?.isPinned)

  const renderIcon = () => {
    if (type === 'pin') {
      return <AccessTime color='primary' fontSize='small' />
    }

    if (isScheduledCheck) {
      return (
        <div className='d-flex align-items-center' style={{ gap: '0.25rem' }}>
          {data?.isPinned ? (
            <DataPinnedItemIcon data-testid='data-pinned-icon' />
          ) : (
            <DataUnpinnedItemIcon data-testid='data-unpinned-icon' />
          )}
          {editScheduleAnchorEl ? (
            <KeyboardArrowUp className={scheduleIconStyle['arrow_icon']} />
          ) : (
            <KeyboardArrowDown className={scheduleIconStyle['arrow_icon']} />
          )}
        </div>
      )
    }
    return <DataUnpinnedItemIcon data-testid='data-unpinned-icon' />
  }

  return (
    <>
      <IconButton
        onClick={(event) => {
          event.stopPropagation()
          if (isScheduledCheck) {
            setEditScheduleAnchorEl(editScheduleAnchorEl ? null : event.currentTarget)
          } else {
            handleScheduleClick?.(data.id, 'pin')
          }
        }}
        id='schedule-icon-btn'
        aria-label='schedule-icon'
        data-testid={'pinIcon'}
        className={scheduleIconStyle['schedule_icon']}
        aria-controls={editScheduleAnchorEl ? 'pinned-item-menu' : undefined}
        aria-haspopup={isScheduledCheck}
        aria-expanded={editScheduleAnchorEl ? 'true' : undefined}
        style={{
          background: isScheduledCheck ? '#ece9f2' : '#fff',
          opacity: isIconDisabled ? 0.5 : 1,
        }}
        disabled={isIconDisabled}
      >
        {renderIcon()}
      </IconButton>
      {editScheduleAnchorEl && (
        <Menu
          id='pinned-item-menu'
          anchorEl={editScheduleAnchorEl}
          open={Boolean(editScheduleAnchorEl)}
          onClose={handleClose}
          style={{
            marginTop: '6px',
            left: '-105px',
          }}
        >
          <MenuItem
            style={{ gap: '0.5rem', color: '#0a0a0a', fontSize: '14px', lineHeight: '20px' }}
            onClick={(event: MouseEvent<HTMLLIElement>) => {
              event.stopPropagation()
              handleScheduleClick?.(data.id, 'update')
              handleClose()
            }}
          >
            <SettingsOutlined style={{ color: '#402080', width: '14px', height: '14px' }} /> Edit
            Pin Settings
          </MenuItem>
          <MenuItem
            style={{ gap: '0.5rem', color: '#e7000b', fontSize: '14px', lineHeight: '20px' }}
            onClick={(event: MouseEvent<HTMLLIElement>) => {
              event.stopPropagation()
              handleScheduleClick?.(data.id, 'remove')
              handleClose()
            }}
          >
            <RedCrossIcon width={14} height={14} />
            {data.isPinned ? 'Unpin' : 'Remove Schedule'}
          </MenuItem>
        </Menu>
      )}
    </>
  )
}

export default memo(ScheduleIconComponent)
